import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CHECKOUT_URL, BUY_ANCHOR } from '../utils/constants';
import { CtaButton } from './CtaButton';
const INCLUDED = ['Complete 6-Module Professional Coaching System', '5 Strategic Bonuses', 'Advanced Technical Progressions', 'Professional Drill Library', 'Session Design System', 'Ready-To-Coach Sessions', 'Tactical & Match Development', 'Player Assessment Resources', 'Lifetime Access', 'Instant Digital Delivery'];
export function Pricing() {
  return <section id={BUY_ANCHOR} aria-labelledby="pricing-title" className="w-full scroll-mt-2 bg-white px-4 py-8 sm:px-6" data-id="element-143" data-mp="1rut1rr1ek235">
      <div className="mx-auto max-w-2xl text-center" data-id="element-144" data-mp="20sv7ukzztkxa">
        <h2 id="pricing-title" className="font-display text-3xl uppercase leading-tight text-charcoal sm:text-4xl" data-id="element-145" data-mp="20vhg6mupk4gk">
          Everything included. One single price.
        </h2>
        <p className="mt-1 text-[13px] text-softgray" data-id="element-146" data-mp="3cao1g22j5x22">No subscriptions. No hidden charges.</p>

        <div className="mt-4 overflow-hidden rounded-2xl border-2 border-brand bg-white text-left shadow-xl shadow-brand/10" data-id="element-147" data-mp="3w1t6br46ct52">
          <div className="bg-brand-dark px-4 py-3 text-center text-white" data-id="element-148" data-mp="9rpatmnnf1v5">
            <h3 className="font-display text-xl uppercase leading-tight sm:text-2xl" data-id="element-149" data-mp="erbmvsrqqc2d">
              Padel Coach Pro™ — Complete Box Set
            </h3>
            <p className="mt-0.5 text-xs text-white/85 sm:text-[13px]" data-id="element-150" data-mp="3daa4vopstn55">
              1 Main Box Set With 6 Modules + 5 Strategic Bonuses
            </p>
          </div>

          <div className="p-4" data-id="element-151" data-mp="3n6ljilcv2p2r">
            <p className="font-head text-[11px] font-semibold uppercase tracking-wider text-softgray" data-id="element-152" data-mp="3n6d9r2c1bzvs">
              What’s Included
            </p>
            <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-153" data-mp="2uihgk7locq3r">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-charcoal" data-id="element-154" data-mp="2zhau200yoh3x">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-155" data-mp="2rf1us36q3k7u" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-4 rounded-xl bg-ivory p-3.5 text-center" data-id="element-156" data-mp="315cx5lardlcm">
              <p className="text-[13px] text-softgray" data-id="element-157" data-mp="2w71p9g40xkx1">
                Regular Price: <span className="line-through" data-id="element-158" data-mp="28i0li664yxy3">$97 USD</span>
              </p>
              <p className="font-display text-5xl leading-none text-urgent sm:text-6xl" data-id="element-159" data-mp="28i8wfsip7t6n">$27 USD</p>
              <span className="mt-1 inline-block rounded-full bg-urgent px-3 py-1 font-head text-[11px] font-semibold uppercase tracking-wide text-white" data-id="element-160" data-mp="23kqq89w2fs2c">
                Save $70
              </span>
              <p className="mt-1.5 font-head text-[11px] font-semibold uppercase tracking-wide text-charcoal" data-id="element-161" data-mp="2dj6g69jcwva9">
                One-Time Payment · Lifetime Access
              </p>
            </div>

            <div className="mt-3 flex flex-col items-center" data-id="element-162" data-mp="3oycxxerz05r0">
              <CtaButton href={CHECKOUT_URL} data-id="element-163" data-mp="9c6sd2ukqx2" />
              <p className="mt-1.5 text-xs text-softgray" data-id="element-164" data-mp="cqcnvapzi99">
                Backed by our 7-day money-back guarantee.
              </p>
              <ul className="mt-1.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-softgray" data-id="element-165" data-mp="3nfleqog6u6kq">
                <li className="flex items-center gap-1.5" data-id="element-166" data-mp="3rh6uchk3wyym">
                  <LockIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-167" data-mp="j0d7b5jm8uiq" />
                  Secure Payment
                </li>
                <li className="flex items-center gap-1.5" data-id="element-168" data-mp="nzgd4s7f74rr">
                  <ZapIcon className="h-3.5 w-3.5 text-urgent" aria-hidden="true" data-id="element-169" data-mp="a935ys2cru3h" />
                  Instant Access
                </li>
                <li className="flex items-center gap-1.5" data-id="element-170" data-mp="e8lndduytn1k">
                  <CreditCardIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-171" data-mp="11z7iy5ns9euo" />
                  Card · Google Pay · Apple Pay
                </li>
              </ul>
              <p className="mt-1 text-[11px] text-softgray" data-id="element-172" data-mp="3f7ik66pi7uni">
                You will be charged in your local currency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}